<template>
  <v-card class="elevation-0">
    <v-container grid-list-xs>
      <v-layout row wrap style="position: relative">
        <v-flex xs6 sm4>
          <span class="body-2 prevent-overflow">{{$t(title)}}</span>
        </v-flex>
        <transition name="fade" mode="out-in">
          <v-flex xs6 sm8 v-if="!shouldReplace">
            <v-layout row wrap>
              <v-flex key="label1" xs12 :sm6="!!value2" class="prevent-overflow">
                <span v-if="label1" class="hidden-xs-only body-2">{{$t(label1)}}: </span>
                <span>{{$t(value1)}}</span>
              </v-flex>

              <v-flex key="label2" xs12 sm6>
                <span v-if="label2" class="hidden-xs-only body-2">{{$t(label2)}}: </span>
                <span>{{$t(value2)}}</span>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex key="replacement" v-if="shouldReplace" xs6 sm4>
            {{$t(openText)}}
          </v-flex>
        </transition>

      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    name: 'insights-header',
    props: ['title', 'label1', 'value1', 'label2', 'value2', 'openText'],
    mixins: [],
    data () {
      return {}
    },
    methods: {},
    computed: {
      open () {
        return this.$parent.isActive
      },
      shouldReplace () {
        return this.open && this.openText
      }
    },
    watch: {},
    mounted () {
    }
  }
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/insights/InsightsHeader.vue